import { useQuery } from "@tanstack/react-query";

import { RepoGraphResponse } from "@oracus/shared/api/repo-graph";

import { apiClient } from "./client.ts";

const REPO_GRAPH_KEY = ["repos", "graph"] as const;

export function useRepoGraph() {
  return useQuery({
    queryKey: REPO_GRAPH_KEY,
    queryFn: () => apiClient.get("/api/repos/graph", RepoGraphResponse),
  });
}
